<template>
  <aside v-if="summary && Number(summary.clients) > 0" class="safari-cancellation-notice" aria-label="Paid Snackbar">
    <svg class="safari-cancellation-notice__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" aria-hidden="true"><rect x="3" y="5" width="18" height="14" rx="3" /><path d="M3 10h18M7 15h4" /></svg>
    <div>
      <strong>Snackbar paid <span aria-hidden="true">·</span> {{ amount }} <span aria-hidden="true">·</span> {{ summary.clients }} {{ Number(summary.clients) === 1 ? 'client' : 'clients' }}</strong>
      <p>Cancelling this reservation will create {{ summary.clients }} {{ Number(summary.clients) === 1 ? 'refund request' : 'refund requests' }}.</p>
    </div>
  </aside>
</template>
<script>
export default {
  name: 'SafariCancellationNotice',
  props: { summary: { type: Object, default: null } },
  computed: { amount() { return new Intl.NumberFormat('en-US', { style: 'currency', currency: this.summary.currency || 'USD' }).format(Number(this.summary.amount)) } }
}
</script>
<style scoped lang="scss">
.safari-cancellation-notice {
  display: flex;
  gap: 12px;
  align-items: flex-start;
  padding: 14px 16px;
  border: 1px solid #edcc88;
  border-left: 4px solid #d28c13;
  border-radius: 8px;
  background: #fff8e9;
  color: #725011;
  strong { display: block; font-size: 15px; line-height: 1.5; }
  strong span { padding: 0 4px; }
  p { margin: 4px 0 0; line-height: 1.5; font-size: 13px; }
  &__icon { flex: 0 0 24px; width: 24px; height: 24px; margin-top: 1px; }
}
</style>
